module.exports = __webpack_public_path__ + "static/media/1022776.dc46aaf2.jpg";